














































import Company from "@/models/company";
import Contact from "@/models/contact";
import CompanyAPI from "@/services/companies";
import ContactAPI from "@/services/contacts";
import { LayoutModule } from "@/store/layout";
import { Component, Vue, Watch } from "vue-property-decorator";
import { get } from "lodash";
import TableActions from "@/components/TableActions.vue";
import { Meta, QueryParams } from "@/models/general";

@Component({
  components: { TableActions },
})
export default class Contacts extends Vue {
  headers = [
    {
      text: this.$t("contacts.model.name"),
      sortable: false,
      value: "name",
    },
    {
      text: this.$t("contacts.model.email"),
      sortable: false,
      value: "email",
    },
    {
      text: this.$t("contacts.model.position"),
      sortable: false,
      value: "position",
    },
    {
      text: this.$t("contacts.model.phone"),
      sortable: false,
      value: "phone",
    },
    {
      text: this.$t("contacts.model.company"),
      sortable: false,
      value: "company",
    },
    {
      text: "",
      sortable: false,
      value: "id",
    },
  ];

  contacts: Contact[] = [];
  companies: Company[] = [];
  meta: Meta = new Meta();
  pagination = {};
  loading = true;
  searchQuery = "";

  created(): void {
    this.getData();
    this.getCompanies();
  }

  companyName(id: string): string {
    const company = this.companies.find((e: Company) => e.id === id);
    return company ? company.name : "";
  }

  async getData(): Promise<void> {
    this.loading = true;
    try {
      // BUG: El search en contactos pareciera no funcionar
      console.log(this.meta);
      const params: QueryParams = {
        page: {
          number: this.meta.pagination.current,
          size: this.meta.pagination.size ? this.meta.pagination.size : 10,
        },
      };

      console.log(params);

      this.searchQuery && this.searchQuery !== ""
        ? (params.search = this.searchQuery)
        : null;

      const r = await ContactAPI.getContacts(params);

      this.contacts = r.data;
      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  async getCompanies(): Promise<void> {
    const params: QueryParams = {
      page: {
        size: -1,
      },
    };
    const companies = await CompanyAPI.getCompanies(params);
    this.companies = companies.data;
  }

  editContact(contact: Contact): void {
    this.$router.push({
      name: "editContact",
      params: { id: String(contact.id), companyId: get(contact, "company.id") },
    });
  }

  // TODO: No está eliminando los contactos
  deleteContact(id: string, companyId: string): void {
    LayoutModule.setDialogTitle("contacts.delete");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();
        await ContactAPI.deleteContact(id, companyId);
        LayoutModule.hideLoader();
        const idx = this.contacts.findIndex((c: Contact) => {
          return c.id === id;
        });
        this.contacts.splice(idx, 1);
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getData();
  }

  @Watch("searchQuery")
  async search(): Promise<void> {
    this.getData();
  }
}
